import { ReactNode } from 'react';
import './Nav.css'

interface ModeBoxProps {
    type: number;
    mode: number;
    isOnline: boolean;
}

function ModeBox({ type, mode, isOnline }: ModeBoxProps): ReactNode {

    function getMode(mavType: number, mode: number, isOnline: boolean): string {
        if (isOnline === false) {
            return "OFFLINE"
        }

        switch (mavType) {
            case 0: return getCopterModeDescription(mode);
            case 1: return getPlaneModeDescription(mode);
            case 2: return getCopterModeDescription(mode);
            default: return getCopterModeDescription(mode);
        }
    }

    function getCopterModeDescription(mode: number): string {
        switch (mode) {
            case 0: return "STABILIZE";
            case 1: return "ACRO";
            case 2: return "ALT HOLD";
            case 3: return "AUTO";
            case 4: return "GUIDED";
            case 5: return "LOITER";
            case 6: return "RTL";
            case 7: return "CIRCLE";
            case 9: return "LAND";
            case 11: return "DRIFT";
            case 13: return "SPORT";
            case 14: return "FLIP";
            case 15: return "AUTOTUNE";
            case 16: return "POSHOLD";
            case 17: return "BRAKE";
            case 18: return "THROW";
            case 19: return "AVOID_ADSB";
            case 20: return "GUIDED_NOGPS";
            case 21: return "SMART_RTL";
            case 22: return "FLOWHOLD";
            case 23: return "FOLLOW";
            case 24: return "ZIGZAG";
            case 25: return "SYSTEMID";
            case 26: return "AUTOROTATE";
            default: return "UNKNOWN MODE";
        }
    }

    function getPlaneModeDescription(mode: number): string {
        switch (mode) {
            case 0: return "MANUAL";
            case 1: return "CIRCLE";
            case 2: return "STABILIZE";
            case 3: return "TRAINING";
            case 4: return "ACRO";
            case 5: return "FLY_BY_WIRE_A";
            case 6: return "FLY_BY_WIRE_B";
            case 7: return "CRUISE";
            case 8: return "AUTOTUNE";
            case 10: return "AUTO";
            case 11: return "RTL";
            case 12: return "LOITER";
            case 13: return "TAKEOFF";
            case 14: return "AVOID_ADSB";
            case 15: return "GUIDED";
            case 16: return "INITIALIZING";
            case 17: return "QSTABILIZE";
            case 18: return "QHOVER";
            case 19: return "QLOITER";
            case 20: return "QLAND";
            case 21: return "QRTL";
            case 22: return "QAUTOTUNE";
            case 23: return "QACRO";
            case 24: return "THERMAL";
            default: return "UNKNOWN MODE";
        }
    }

    return (
        <div className='mode-box'>{getMode(type, mode, isOnline)}</div>
    )
}

export default ModeBox;